export const RENDER_NEWSLETTER = 'render_newsletter';
export const RENDER_ABOUT = 'render_about';
export const RENDER_HELP = 'render_help';
export const RENDER_SERVICES = 'render_services';

export const NEWSLETTER_COLUMN = {
    title: __('Rejoignez notre communauté'),
    columnActiveKey: 'newsletterActive',
    mods: { newsletter: true },
    items: [
        {
            render: RENDER_NEWSLETTER
        }
    ]
};

// eslint-disable-next-line import/prefer-default-export
export const COLUMN_MAP = [
    // NEWSLETTER_COLUMN,
    {
        title: __('Aide et commandes'),
        mods: { help: true },
        items: [
            {
                render: RENDER_HELP
            }
        ]
    },
    {
        title: __('Les services Peggy Sage'),
        mods: { services: true },
        items: [
            {
                render: RENDER_SERVICES
            }
        ]
    },
    {
        title: __('À propos de Peggy Sage'),
        mods: { about: true },
        items: [
            {
                render: RENDER_ABOUT
            }
        ]
    }
];
